import {
  useDatasetsSyncingToAnalytics,
  UseDatasetsSyncingToAnalyticsParams,
} from '@monorepo/shared/hooks/analyticsSync/useDatasetsSyncingToAnalytics';
import { DatasetType } from 'mapistry-shared';
import { useMemo } from 'react';

export const useLogsSyncingToAnalytics = ({
  config,
  organizationId,
}: UseDatasetsSyncingToAnalyticsParams) => {
  const { datasetsSyncingToAnalytics, ...queryInfo } =
    useDatasetsSyncingToAnalytics({ organizationId, config });
  const logIdsSyncingToAnalytics = useMemo(
    () =>
      datasetsSyncingToAnalytics
        ?.filter((dataset) => dataset.type === DatasetType.LOG)
        .map((dataset) => dataset.originId),
    [datasetsSyncingToAnalytics],
  );
  return {
    logIdsSyncingToAnalytics,
    ...queryInfo,
  };
};
